import React, { useEffect, useState } from 'react';

import { Route, Link, Switch, BrowserRouter, Redirect, useHistory } from 'react-router-dom'
import './App.css';
import CardWrap from './components/card-wrap/card-wrap.component'
import ContentCard from './components/content-card/content-card.component'
import { UserProvider } from './utils/userContext';
import { NewPost } from './components/new-post/new-post.component';
import NavBar from './components/nav-bar/nav-bar.component';
import Footer from './components/blog-footer/footer.component'
import { EditPost } from './components/edit-post/edit-post.component';
import ManagePost from './components/manage-post/manage-post.component';
import { NotFound } from './components/notfound/notfound.component';
import Profile from './components/profile/profile.component';
import Bookmark from './components/bookmark/bookmark.component'
import 'semantic-ui-css/semantic.min.css'
import { Helmet } from "react-helmet";
import TagsPage from './components/tags-page/tags-page.component';



function onRedirect(history, path) {

  history.push(path)
}

function App() {
  //  let person =
  //         console.log(person)
  let history = useHistory();
  let user = {
    "loggedIn": false,
    "token": "",
    "id": "",
    "email": "",
    "nicename": "",
    "firstName": "",
    "lastName": "",
    "displayName": "Anonymous",
    "profileImage": "https://www.borntodev.com/wp-content/uploads/2020/02/38033354_1904287879629496_1565701761929314304_n.png"
  };

  if (localStorage.getItem("btd-bdt")) {
    user = JSON.parse(localStorage.getItem("btd-bdt"))

  }



  let [userData, setUserData] = useState(user);


  return (
    <div className="App">
      <Helmet>
        <link rel="shortcut icon" href="borntoDevLogo.png" sizes="16x16" />
        <link rel="canonical" href="http://www.borntodev.com" />
        <meta charSet="utf-8" />
        <title>borntoDev Creator | อัพสกิลสายไอที และ การเขียนโปรแกรมไปพร้อมกัน</title>
        <meta property="image" content="borntoDevLogo.png" />
        <meta property="og:title" content="borntoDev Creator | อัพสกิลสายไอที และ การเขียนโปรแกรมไปพร้อมกัน" />
        <meta property="og:quote" content="borntoDev Creator | อัพสกิลสายไอที และ การเขียนโปรแกรมไปพร้อมกัน" />
        <meta property="og:image" content="https://www.borntodev.com/wp-content/uploads/2020/02/38033354_1904287879629496_1565701761929314304_n.png" />
        <meta property="og:description" content="borntoDev Creator" />

      </Helmet>
      <UserProvider value={{ userData, setUserData }}>
        <NavBar userData={userData} setUserData={setUserData} goHome={() => onRedirect(history, '/')} />
        <Switch>
          <Route path="/newpost" component={NewPost} />
          <Route path="/managepost" component={ManagePost} />
          <Route path="/edit/:contentId" component={EditPost} />
          <Route exact path="/" component={CardWrap} />
          <Route path="/search" component={CardWrap} />
          <Route path="/filter/:filterName" component={CardWrap} />
          <Route path="/tag/:tagName/filter/:filterName" component={CardWrap} />
          <Route path="/tag/:tagName/" component={CardWrap} />
          <Route path="/list/" component={Bookmark} />
          <Route path="/tags" component={TagsPage} />

          <Route path="/404/" component={NotFound} />


          <Route path="/:authorName/:contentId" component={ContentCard} />
          <Route path="/:authorName" component={Profile} />
          {/* <Route path="/:otherPath" component={NotFound} /> */}
        </Switch>
        <Footer/>
      </UserProvider>
    </div >
  );
}

export default App;


